import React from 'react';
import { englishFacts, englishParagraphs, privacy, terms, termsUpdated } from '../data/legal';
import { renderRich } from '../utils/richText';
import { LegalBlocks } from './LegalBlocks';
import { Section } from './Section';
export function LegalSections() {
  return <>
      <Section id="terminos" number="08" title="Términos y Condiciones" subtitle={termsUpdated} data-id="element-70" data-mp="pf21xu8pxlin">
        <LegalBlocks blocks={terms} data-id="element-71" data-mp="3oup8uyah2h5t" />
      </Section>

      <Section id="privacidad" number="09" title="Política de Privacidad" data-id="element-72" data-mp="3ow0e72jkfwz1">
        <LegalBlocks blocks={privacy} data-id="element-73" data-mp="3tulef1ytignh" />
      </Section>

      <Section id="english" number="10" title="Business summary (English)" data-id="element-74" data-mp="3tr5zq09239ml">
        <div lang="en" className="max-w-[860px]" data-id="element-75" data-mp="1og5z1bznrp0">
          <dl className="mb-6 grid grid-cols-1 gap-x-6 gap-y-2 text-[14.8px] sm:grid-cols-[200px_1fr]" data-id="element-76" data-mp="6gzf9m3n80o0">
            {englishFacts.map(fact => <div key={fact.label} className="contents" data-id="element-77" data-mp="363pgdn3rqp7s">
                <dt className="font-bold text-fg" data-id="element-78" data-mp="3a4riqcszfhdz">{fact.label}</dt>
                <dd className="mb-2 break-words text-body sm:mb-0" data-id="element-79" data-mp="59cjqc9jtomg">{fact.value}</dd>
              </div>)}
          </dl>
          {englishParagraphs.map(p => <p key={p} className="mb-3.5 text-[14.8px] leading-relaxed text-body" data-id="element-80" data-mp="ccfm6w9evxz">
              {renderRich(p)}
            </p>)}
        </div>
      </Section>
    </>;
}